// Styles
import styled from 'styled-components/macro';
import Breakpoints from '../../../../themes/constants/breakpoints';

export const NewsSliderWrapMain = styled.div`
    margin: ${({ theme }) => `0 -${theme.paddings.inner.mobile.paddingLeft}`};
    & .swiper-container {
        ${({ theme }) => theme.paddings.inner.mobile};
        width: 100%;
        padding-bottom: 2px;
        overflow: unset;
    }
    & .swiper-scrollbar {
        width: auto;
        height: 2px;
        left: ${({ theme }) => theme.paddings.inner.mobile.paddingLeft};
        right: ${({ theme }) => theme.paddings.inner.mobile.paddingRight};
        bottom: 0;
        background: ${({ theme }) => theme.palette.greyLight};
    }
    & .swiper-slide {
        display: flex;
        justify-content: center;
        align-items: stretch;
        // Fix bug in Swiper after resize...
        margin-top: 0 !important;
        margin-bottom: 20px;
    }
    & .swiper-scrollbar-drag {
        background: ${({ theme }) => theme.palette.secondary};
    }
    @media only screen and (${Breakpoints.TABLET}) {
        margin: ${({ theme }) => `0 -${theme.paddings.inner.tablet.paddingLeft}`};
        & .swiper-container {
            ${({ theme }) => theme.paddings.inner.tablet};
            padding-bottom: 5px;
        }
        & .swiper-wrapper {
            flex-flow: column wrap;
            height: 668px;
        }
        & .swiper-slide {
            max-width: 220px;
            height: inherit;
            max-height: 310px;
        }
        & .swiper-scrollbar {
            left: ${({ theme }) => theme.paddings.inner.tablet.paddingLeft};
            right: ${({ theme }) => theme.paddings.inner.tablet.paddingRight};
        }
    }
    @media only screen and (${Breakpoints.LAPTOP}) {
        margin: ${({ theme }) => `0 -${theme.paddings.inner.desktop.paddingLeft}`};
        & .swiper-container {
            ${({ theme }) => theme.paddings.inner.desktop};
            padding-bottom: 25px;
        }
        & .swiper-scrollbar {
            width: 100%;
            max-width: 540px;
            left: 50%;
            right: unset;
            transform: translateX(-50%);
        }
    }
`;
export const NewsSliderWrapInline = styled.div`
    & .swiper-container {
        width: 100%;
        padding-bottom: 20px;
    }
    & .swiper-scrollbar {
        width: 100%;
        max-width: 540px;
        height: 2px;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        background: ${({ theme }) => theme.background.swiper.scrollbar.scrollbar.primary};
    }
    & .swiper-scrollbar-drag {
        background: ${({ theme }) => theme.palette.secondary};
    }
    @media only screen and (${Breakpoints.TABLET}) {
        & .swiper-container {
            padding-bottom: 20px;
        }
    }
    @media only screen and (${Breakpoints.LAPTOP}) {
        & .swiper-container {
            padding-bottom: 25px;
        }
    }
`;
